import React from "react";
import "./RoyalBridgeFooter.css";
import RoyalLogo from "../../../assets/images/mrg_logo_storevisit1.png";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getCurrentTranslations } from "../../../utilities/helper";
import { useDataLastUpdated } from "../../../utilities/useDataLastUpdated";

const RoyalBridgeFooter = ({ showMenu = true, extendedFooter = false }) => {
    const navigate = useNavigate();
    const dataLastUpdated = useDataLastUpdated();

    const footerItems = [
        {
            title: getCurrentTranslations("footer", "privacyPolicy"),
            link: getCurrentTranslations("footer", "privacyPolicyUrl"),
        },
    ];

    return (
        <>
        {extendedFooter ? (
            <div className="royalBridgeFooter__mainContainer static w-full h-fit flex justify-between p-[58px] flex-col lg:flex-row">
                <div className="flex gap-3 flex-col lg:flex-row">
                    <div className="flex flex-col lg:w-[324px]">
                        <div className="text-white font-openSans text-[20px] font-semibold leading-[24px] mb-6">
                            {getCurrentTranslations("footer", "textSupport")}
                        </div>

                        <div className="text-[#D1D5DB] font-openSansCondensedLight text-[16px] font-normal leading-[24px] mb-3">
                            Support resets are managed by
                            Royal Caribbean.
                            For support please contact your Royal Caribbean account manager.
                        </div>
                    </div>

                    <div className="flex flex-col lg:w-[324px]">
                        <div className="text-white font-openSans text-[20px] font-semibold leading-[24px] mb-6">
                            {getCurrentTranslations("footer", "textQuickLinks")}
                        </div>

                        {/* <div
                            className="text-[#D1D5DB] font-openSansCondensedLight text-[16px] font-normal leading-[24px] mb-3 cursor-pointer"
                            onClick={() => window.open(getCurrentTranslations("footer", "privacyPolicyUrl"), "_blank", "noopener,noreferrer")}
                        >
                            {getCurrentTranslations("footer", "privacyPolicy")}
                        </div> */}

                        <div className="text-[#D1D5DB] font-openSansCondensedLight text-[16px] font-normal leading-[24px] cursor-pointer"
                            onClick={() => window.open("https://www.myclubroyal.co.uk/#/terms", "_blank", "noopener,noreferrer")}>
                            {getCurrentTranslations("footer", "termsOfService")}
                        </div>
                    </div>
                </div>

                <div className="flex flex-col">
                    <div className="text-[#D1D5DB] font-openSansCondensedLight text-[16px] font-normal leading-[24px] mt-12 text-left lg:text-right">
                        {getCurrentTranslations("footer", "dataLastUpdated")} {dataLastUpdated}
                    </div>
                    <div className="text-[#D1D5DB] font-openSansCondensedLight text-[16px] font-normal leading-[24px] text-left lg:text-right">
                        © 2026 Royal Caribbean International
                    </div>
                </div>
            </div>
        ) : (
        <div className="royalBridgeFooter__mainContainer static w-full h-fit flex items-center justify-center">
            <div
                className={`royalBridgeFooter pt-9 pb-12 flex flex-col lg:flex-row items-center w-fit`}
            >
                {/* Crown mark plus the product name in Kapra, replacing the old
                    "My Royal Genie" lockup. The crown is white with a transparent
                    background, so it sits on the navy footer without a plate. */}
                <div
                    className={`flex items-center gap-3 ${
                        showMenu ? "mt-[2rem] lg:mt-0 mr-16 mb-10 lg:mb-0" : ""
                    }`}
                >
                    <img className="h-[32px] w-auto object-contain" src={RoyalLogo} alt="" />
                    <span className="font-kapraRegular text-white text-[16px] leading-none uppercase whitespace-nowrap">
                        Royal Bridge
                    </span>
                </div>

                {showMenu && (
                    <ul className="flex flex-wrap items-center text-center w-full text-base tracking-[0.113rem] font-openSans font-normal sm:mt-0">
                        {footerItems.map((item, index) => (
                            <li key={index} className="text-center mx-auto">
                                <a
                                    href={item.link}
                                    className="text-center mx-auto"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (item.link.includes("https")) {
                                            window.open(
                                                item.link,
                                                "_blank",
                                                "noopener, noreferrer"
                                            );
                                        } else {
                                            navigate(item.link);
                                        }
                                    }}
                                >
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
        )}
        </>
    );
};

export default RoyalBridgeFooter;
